import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-721f8584"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-xl mb-2" }, "Фильтры", -1))
const _hoisted_2 = { class: "InvoicesHistoryFilters__row" }
const _hoisted_3 = { class: "InvoicesHistoryFilters__row w-full mt-3" }
const _hoisted_4 = { class: "InvoicesHistoryFilters__actions" }
const _hoisted_5 = { class: "ToggleBtnHolder" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("form", {
    class: "InvoicesHistoryFilters",
    onSubmit: _cache[38] || (_cache[38] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["prevent"]))
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_the_input, {
        value: _ctx.filters_state.search,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters_state.search) = $event)),
        placeholder: "Номер накладной"
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        value: _ctx.filters_state.orderNumber,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters_state.orderNumber) = $event)),
        placeholder: "Номер заказа"
      }, null, 8, ["value"]),
      _createVNode(_component_the_select, {
        placeholder: "Клиент",
        loading: _ctx.data_state.companies.is_loading,
        failed: _ctx.data_state.companies.is_failed,
        "error-text": "При получении списка клиентов произошла ошибка",
        options: _ctx.data_state.companies.list,
        value: _ctx.filters_state.companyId,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters_state.companyId) = $event)),
        "infinite-scroll": "",
        onRefresh: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page))),
        onLoadmore: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadMoreCompanies(_ctx.data_state.companies.pagination.current_page + 1))),
        onSearch: _ctx.searchCompanies,
        onOptionBySearch: _ctx.unshiftFindedCompany,
        class: "mt-2",
        "can-deselect": ""
      }, null, 8, ["loading", "failed", "options", "value", "onSearch", "onOptionBySearch"]),
      _createVNode(_component_the_select, {
        placeholder: "Менеджер",
        value: _ctx.filters_state.managerId,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters_state.managerId) = $event)),
        loading: _ctx.data_state.managers.is_loading,
        failed: _ctx.data_state.managers.is_failed,
        "error-text": "При получении списка менеджеров произошла ошибка",
        options: _ctx.data_state.managers.list,
        "infinite-scroll": "",
        "search-by": "name",
        "select-by": "id",
        label: "name",
        onRefresh: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadManagers(_ctx.data_state.managers.pagination.current_page))),
        onLoadmore: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loadMoreManagers(_ctx.data_state.managers.pagination.current_page + 1))),
        class: "mt-2",
        "can-deselect": ""
      }, null, 8, ["value", "loading", "failed", "options"]),
      _createVNode(_component_the_input, {
        value: _ctx.filters_state.dopInvoiceNumber,
        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters_state.dopInvoiceNumber) = $event)),
        placeholder: "Номер накл. заказчика"
      }, null, 8, ["value"]),
      _createVNode(_component_the_select, {
        placeholder: "Статус",
        value: _ctx.filters_state.statusIds,
        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filters_state.statusIds) = $event)),
        loading: _ctx.data_state.statuses.is_loading,
        failed: _ctx.data_state.statuses.is_failed,
        "error-text": "При получении списка произошла ошибка",
        options: _ctx.data_state.statuses.list,
        "infinite-scroll": "",
        multiselect: "",
        onRefresh: _ctx.loadStatuses,
        class: "mt-2",
        "can-deselect": ""
      }, null, 8, ["value", "loading", "failed", "options", "onRefresh"]),
      _createVNode(_component_the_input, {
        value: _ctx.filters_state.startTime,
        "onUpdate:value": [
          _cache[10] || (_cache[10] = ($event: any) => ((_ctx.filters_state.startTime) = $event)),
          _ctx.onDateChange
        ],
        type: "date",
        placeholder: "Дата создания от"
      }, null, 8, ["value", "onUpdate:value"]),
      _createVNode(_component_the_input, {
        value: _ctx.filters_state.endTime,
        "onUpdate:value": [
          _cache[11] || (_cache[11] = ($event: any) => ((_ctx.filters_state.endTime) = $event)),
          _ctx.onDateChange
        ],
        type: "date",
        placeholder: "Дата создания до"
      }, null, 8, ["value", "onUpdate:value"]),
      _createVNode(_component_the_input, {
        value: _ctx.filters_state.deliveryDateFrom,
        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.filters_state.deliveryDateFrom) = $event)),
        type: "date",
        placeholder: "Дата доставки от"
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        value: _ctx.filters_state.deliveryDateTo,
        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.filters_state.deliveryDateTo) = $event)),
        type: "date",
        placeholder: "Дата доставки до"
      }, null, 8, ["value"]),
      _createVNode(_component_the_select, {
        value: _ctx.filters_state.senderCity,
        "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.filters_state.senderCity) = $event)),
        placeholder: "Город отправителя",
        loading: _ctx.data_state.cities.is_loading,
        options: _ctx.data_state.cities.list,
        failed: _ctx.data_state.cities.is_failed,
        "error-text": "При получении списка городов произошла ошибка",
        "search-by": "name",
        "select-by": "id",
        label: "name",
        "infinite-scroll": "",
        "search-without-refresh": "",
        onRefresh: _cache[15] || (_cache[15] = ($event: any) => (_ctx.loadCities(_ctx.data_state.cities.pagination.current_page))),
        onLoadmore: _cache[16] || (_cache[16] = ($event: any) => (_ctx.loadMoreCities(_ctx.data_state.cities.pagination.current_page + 1))),
        class: "mt-2",
        "can-deselect": ""
      }, null, 8, ["value", "loading", "options", "failed"]),
      _createVNode(_component_the_select, {
        value: _ctx.filters_state.receiverCity,
        "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.filters_state.receiverCity) = $event)),
        placeholder: "Город получателя",
        loading: _ctx.data_state.cities.is_loading,
        options: _ctx.data_state.cities.list,
        failed: _ctx.data_state.cities.is_failed,
        "error-text": "При получении списка городов произошла ошибка",
        "search-by": "name",
        "select-by": "id",
        label: "name",
        "infinite-scroll": "",
        "search-without-refresh": "",
        onRefresh: _cache[18] || (_cache[18] = ($event: any) => (_ctx.loadCities(_ctx.data_state.cities.pagination.current_page))),
        onLoadmore: _cache[19] || (_cache[19] = ($event: any) => (_ctx.loadMoreCities(_ctx.data_state.cities.pagination.current_page + 1))),
        class: "mt-2",
        "can-deselect": ""
      }, null, 8, ["value", "loading", "options", "failed"]),
      _createVNode(_component_the_input, {
        value: _ctx.filters_state.senderAddress,
        "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.filters_state.senderAddress) = $event)),
        placeholder: "Адрес отправителя"
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        value: _ctx.filters_state.receiverAddress,
        "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.filters_state.receiverAddress) = $event)),
        placeholder: "Адрес получателя"
      }, null, 8, ["value"]),
      _withDirectives(_createVNode(_component_the_select, {
        placeholder: "Вид перевозки",
        options: _ctx.SHIPMENT_TYPES,
        value: _ctx.filters_state.shipmentType,
        "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.filters_state.shipmentType) = $event)),
        searchable: false,
        class: "mt-2",
        "can-deselect": ""
      }, null, 8, ["options", "value"]), [
        [_vShow, _ctx.state.is_visible]
      ])
    ]),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _createVNode(_component_the_select, {
            placeholder: "Доп услуги",
            value: _ctx.filters_state.hasAdditionalService,
            "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.filters_state.hasAdditionalService) = $event)),
            options: _ctx.INVOICE_ADDITIONAL_SERVICES,
            "select-by": "value",
            class: "mt-2",
            "can-deselect": ""
          }, null, 8, ["value", "options"]),
          _createVNode(_component_the_select, {
            placeholder: "Отмена заказа",
            value: _ctx.filters_state.isCancelled,
            "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.filters_state.isCancelled) = $event)),
            options: _ctx.INVOICE_CANCEL,
            "select-by": "value",
            class: "mt-2",
            "can-deselect": ""
          }, null, 8, ["value", "options"]),
          _createVNode(_component_the_select, {
            placeholder: "Плательщик",
            options: _ctx.PAYMENT_TYPE_OPTIONS,
            value: _ctx.filters_state.paymentType,
            "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.filters_state.paymentType) = $event)),
            searchable: false,
            class: "mt-2",
            "can-deselect": ""
          }, null, 8, ["options", "value"]),
          _createVNode(_component_the_select, {
            placeholder: "Вид оплаты",
            value: _ctx.filters_state.paymentMethods,
            "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.filters_state.paymentMethods) = $event)),
            options: _ctx.INVOICE_PAYMENT_METHODS,
            class: "mt-2",
            "can-deselect": "",
            multiselect: ""
          }, null, 8, ["value", "options"]),
          _createVNode(_component_the_select, {
            placeholder: "Наличие Биллинга",
            value: _ctx.filters_state.billingEnabled,
            "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.filters_state.billingEnabled) = $event)),
            options: _ctx.INVOICE_BILLING,
            "select-by": "value",
            class: "mt-2",
            "can-deselect": ""
          }, null, 8, ["value", "options"]),
          _createVNode(_component_the_select, {
            placeholder: "Статус вычисления",
            value: _ctx.filters_state.calculationStatus,
            "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.filters_state.calculationStatus) = $event)),
            options: _ctx.INVOICE_CALCULATION,
            class: "mt-2",
            "can-deselect": "",
            multiselect: ""
          }, null, 8, ["value", "options"]),
          _createVNode(_component_the_select, {
            placeholder: "Доп накладные",
            value: _ctx.filters_state.hideDopInvoices,
            "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.filters_state.hideDopInvoices) = $event)),
            options: _ctx.HIDE_DOP_INVOICES_OPTIONS,
            class: "mt-2",
            "can-deselect": "",
            "select-by": "key"
          }, null, 8, ["value", "options"]),
          _createVNode(_component_the_input, {
            value: _ctx.filters_state.takeDateFrom,
            "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.filters_state.takeDateFrom) = $event)),
            type: "date",
            placeholder: "Дата забора от"
          }, null, 8, ["value"]),
          _createVNode(_component_the_input, {
            value: _ctx.filters_state.takeDateTo,
            "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.filters_state.takeDateTo) = $event)),
            type: "date",
            placeholder: "Дата забора до"
          }, null, 8, ["value"]),
          _createVNode(_component_the_select, {
            placeholder: "Самовывоз",
            value: _ctx.filters_state.isPickup,
            "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.filters_state.isPickup) = $event)),
            options: _ctx.SELF_DELIVERY_OPTIONS,
            class: "mt-2",
            "can-deselect": "",
            "select-by": "key"
          }, null, 8, ["value", "options"]),
          _createVNode(_component_the_select, {
            placeholder: "Самопривоз",
            value: _ctx.filters_state.isSelfDelivery,
            "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.filters_state.isSelfDelivery) = $event)),
            options: _ctx.PICKUP_OPTIONS,
            class: "mt-2",
            "can-deselect": "",
            "select-by": "key"
          }, null, 8, ["value", "options"]),
          _createVNode(_component_the_input, {
            value: _ctx.filters_state.receiverComment,
            "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.filters_state.receiverComment) = $event)),
            placeholder: "Комментарий получателя"
          }, null, 8, ["value"]),
          _createVNode(_component_checkbox, {
            value: _ctx.filters_state.archive,
            "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.filters_state.archive) = $event)),
            label: "Архив",
            "return-integer": ""
          }, null, 8, ["value"]),
          _createVNode(_component_checkbox, {
            value: _ctx.filters_state.export,
            "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.filters_state.export) = $event)),
            label: "Экспорт",
            "return-integer": ""
          }, null, 8, ["value"]),
          _createVNode(_component_checkbox, {
            value: _ctx.filters_state.import,
            "onUpdate:value": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.filters_state.import) = $event)),
            label: "Импорт",
            "return-integer": ""
          }, null, 8, ["value"])
        ], 512), [
          [_vShow, _ctx.state.is_visible]
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_the_button, {
          class: "ToggleBtn second extra-large",
          disabled: _ctx.loading,
          onClick: _ctx.toggle
        }, {
          default: _withCtx(() => [
            _createElementVNode("i", {
              class: _normalizeClass([
                            'fas fa-angle-down transition-all',
                            { ToggleBtn__rotate: _ctx.state.is_visible },
                        ])
            }, null, 2)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      _createVNode(_component_the_button, {
        class: "second text small mr-3",
        disabled: _ctx.loading,
        onClick: _ctx.reset
      }, {
        default: _withCtx(() => [
          _hoisted_6,
          _createTextVNode(" Сбросить ")
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_the_button, {
        class: "primary text small",
        loading: _ctx.loading,
        type: "submit"
      }, {
        default: _withCtx(() => [
          _hoisted_7,
          _createTextVNode(" Поиск ")
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ], 32))
}